export default {
  apply: () => {
    console.dump = (arg) => {
      console.log(JSON.parse(JSON.stringify(arg)))
    }
  }
}